import { MaybeRefOrGetter, toValue } from 'vue';

import { t } from '../../../locale';
import { ValidationMessage, ValidationRule } from '../useValidation.types';
import isDefined from '../utils/isDefined';

interface Config {
  max: MaybeRefOrGetter<number>;
  message?: ValidationMessage;
}

export default function maxValue(config: Config): ValidationRule {
  return {
    name: 'maxValue',
    validator(value) {
      const max = toValue(config.max);

      return !isDefined(value) || Number(value) <= max;
    },
    message: config.message || (() => t('ll.validation.maxValue', { max: String(toValue(config.max)) })),
  };
}
